export const sanitizeOptionValue = (value: any): string => {
  return Number.isInteger(parseInt(value)) ? parseInt(value) : value;
};
